import { useQuery } from 'react-query'

import type { AppliedFilterOptionRange } from 'features/filters/types'
import { useProductService } from 'features/products/service'
import type { Product } from 'features/products/types'
import type { Filters } from 'types/project'

export function useHierarchyProducts(
  projectId: string,
  hierarchy: string,
  localFilters?: Filters,
): {
  hierachyProductsData: Product[] | undefined
  isLoading: boolean
} {
  const productService = useProductService()

  const createTimeFilter = localFilters?.values?.find(
    (f) => f.field === 'create_time',
  ) as AppliedFilterOptionRange | undefined
  const dateMin = createTimeFilter?.min
  const dateMax = createTimeFilter?.max

  const { data: hierachyProductsData, isLoading } = useQuery(
    [
      'getProductsForHierarchy',
      projectId,
      hierarchy,
      dateMin,
      dateMax,
      'reviews_only',
    ],
    () =>
      productService.getProductsForHierarchy(
        'getProductsForHierarchy',
        projectId,
        hierarchy,
        dateMin,
        dateMax,
        'reviews_only',
      ),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: !!projectId,
    },
  )

  return { hierachyProductsData, isLoading }
}
